import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DatePicker, Space } from "antd";
import Tooltip from "@mui/material/Tooltip";
import {
  FaMoneyBillWave,
  FaReceipt,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { RiMoneyDollarCircleLine } from "react-icons/ri";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import useFetch from "../../../components/shared/useFetch";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

const { RangePicker } = DatePicker;

const MonthlyStatementChild = () => {
  let navigate = useNavigate();
  // const [financial_year] = useAtom(fYear);
  const [{ errorLogApi, user }] = useAtom(gbState);
  const [financial_year] = useState(user?.current_financial_year);
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [incomeData, setIncomeData] = useState(null);
  const [expenseData, setExpenseData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [salaryData, setSalaryData] = useState(null);
  const [incomeTypeOthers, setIncomeTypesOther] = useState(null);
  const [incomeTypeCash, setIncomeTypeCash] = useState(null);
  const [groupIncomeTypeCash, setGroupIncomeTypeCash] = useState(null);
  const [incomeTotalCash, setIncomeTotalCash] = useState(null);
  const [incomeTotalOther, setIncomeTotalOther] = useState(null);
  const [incomeTotalCashSubs, setIncomeTotalCashSubs] = useState(null);
  const [incomeTotalCashSalary, setIncomeTotalCashSalary] = useState(null);
  const [incomeTotalOtherSubs, setIncomeTotalOtherSubs] = useState(null);
  const [incomeTotalOtherSalary, setIncomeTotalOtherSalary] = useState(null);
  const [expenseTypeCash, setExpenseTypeCash] = useState(null);
  const [subscriptionTypeCash, setSubscriptionTypeCash] = useState(null);
  const [salaryTypeCash, setSalaryTypeCash] = useState(null);
  const [groupExpenseTypeCash, setGroupExpenseTypeCash] = useState(null);
  const [expenseTypeOthers, setExpenseTypesOther] = useState(null);
  const [subscriptionTypeOthers, setSubscriptionTypesOther] = useState(null);
  const [salaryTypesOther, setSalaryTypesOther] = useState(null);
  const [subscriptionTypeOthersData, setSubscriptionTypesOtherData] =
    useState(null);
  const [salaryTypeOthersData, setSalaryTypesOtherData] = useState(null);
  const [expenseTotalCash, setExpenseTotalCash] = useState(null);
  const [expenseTotalOther, setExpenseTotalOther] = useState(null);
  const [receiptTotalCash, setReceiptTotalCash] = useState(null);
  const [salaryTotalCash, setSalaryTotalCash] = useState(null);

  const [activeBanks, setActiveBanks] = useState();
  const [openingClosingBalances, setOpeningClosingBalances] = useState([]);
  const [openingBalTotal, setOpeningBalTotal] = useState();
  const [closingBalTotal, setClosingBalTotal] = useState();

  const [incomeDate, setIncomeDate] = useState(null);
  const [unfilteredData, setUnfilteredData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [searchInput, setSearchInput] = useState(null);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  let urlLink = `${process.env.REACT_APP_API_URL}/income/${user.church_id}`;

  //Fetching income data for the page
  const { data, loading, error, refetch } = useFetch(urlLink);

  useEffect(() => {
    setIncomeData(
      data?.incomes?.filter((d) => d?.financial_year === financial_year)
    );
  }, [data, financial_year]);

  //Remove and set cash Records
  useEffect(() => {
    setIncomeTypeCash(incomeData?.filter((d) => d?.income_source === "Cash"));

    let tempIncomeTypeOther = incomeData?.filter(
      (d) => d?.income_source !== "Cash"
    );
    setIncomeTypesOther(tempIncomeTypeOther);
  }, [incomeData]);

  //Group Income Type Cash
  useEffect(() => {
    function summarizeByCategory(data) {
      const summary = {};

      data?.forEach((item) => {
        const category_name = item?.category_id?.category_name;
        const amount = item?.amount;

        if (summary[category_name]) {
          summary[category_name] += amount;
        } else {
          summary[category_name] = amount;
        }
      });

      return Object.entries(summary).map(([category, total_amount]) => ({
        category,
        total_amount,
      }));
    }
    // if (incomeData?.length) {
    setGroupIncomeTypeCash(summarizeByCategory(incomeTypeCash));
    //}
  }, [incomeTypeCash]);

  //Add total of groupedcash
  useEffect(() => {
    function calculateTotalAmount(data) {
      return data?.reduce((acc, item) => acc + item?.total_amount, 0);
    }
    setIncomeTotalCash(calculateTotalAmount(groupIncomeTypeCash));
  }, [groupIncomeTypeCash]);

  //Add Total Income Others
  useEffect(() => {
    function calculateTotalAmount(data) {
      return data?.reduce((acc, item) => acc + item?.amount, 0);
    }
    setIncomeTotalOther(calculateTotalAmount(incomeTypeOthers));
  }, [incomeTypeOthers]);

  // Fecthing member subscribtion collection list--
  urlLink = `${process.env.REACT_APP_API_URL}/receipt/church/${user?.church_id}`;
  const {
    data: subData,
    loading: subLoading,
    error: subError,
    refetch: subRefetch,
  } = useFetch(urlLink);
  useEffect(() => {
    setSubscriptionData(
      subData?.filter((d) => d?.financial_year === financial_year)
    );
  }, [subData, financial_year]);

  //Remove and set Subscribe cash Records subscriptionTypeCash,subscriptionTypesOther
  useEffect(() => {
    setSubscriptionTypeCash(
      subscriptionData?.filter((d) => d?.payment_mode == "1")
    );
    let tempExpenseTypeOther = subscriptionData?.filter(
      (d) => d?.payment_mode != "1"
    );
    setSubscriptionTypesOther(tempExpenseTypeOther);
  }, [subscriptionData, financial_year]);
  useEffect(() => {
    const sum = subscriptionTypeCash?.reduce(
      (accumulator, currentValue) =>
        accumulator + parseInt(currentValue.amount),
      0
    );
    setReceiptTotalCash([
      {
        category: "Subscription",
        total_amount: parseInt(sum),
      },
    ]);
    setIncomeTotalCashSubs(parseInt(sum));
  }, [subscriptionTypeCash]);

  useEffect(() => {
    const data = {};
    const dataArray = subscriptionTypeOthers?.map((subs) => {
      return {
        ...data,
        description:
          subs?.subscriber_id?.first_name +
          " " +
          subs?.subscriber_id?.last_name,
        type: subs?.month,
        head: "Subscription",
        amount: subs?.amount,
      };
    });
    setSubscriptionTypesOtherData(dataArray);
    const sum = subscriptionTypeOthers?.reduce(
      (accumulator, currentValue) =>
        accumulator + parseInt(currentValue.amount),
      0
    );
    setIncomeTotalOtherSubs(parseInt(sum));
  }, [subscriptionTypeOthers]);

  // Fecthing member salary collection list--
  urlLink = `${process.env.REACT_APP_API_URL}/salary/${user?.church_id}`;
  const {
    data: salariesData,
    loading: salaryLoading,
    error: salaryError,
    refetch: salaryRefetch,
  } = useFetch(urlLink);
  useEffect(() => {
    setSalaryData(
      salariesData?.salaries?.filter(
        (d) => d?.financial_year === financial_year
      )
    );
  }, [salariesData, financial_year]);

  useEffect(() => {
    setSalaryTypeCash(salaryData?.filter((d) => d?.status == "1"));
    let tempExpenseTypeOther = salaryData?.filter((d) => d?.status != "1");
    setSalaryTypesOther(tempExpenseTypeOther);
  }, [salaryData, financial_year]);

  useEffect(() => {
    const sum = salaryTypeCash?.reduce(
      (accumulator, currentValue) =>
        accumulator + parseInt(currentValue.amount),
      0
    );
    setSalaryTotalCash([
      {
        category: "Salary",
        total_amount: parseInt(sum),
      },
    ]);
    setIncomeTotalCashSalary(parseInt(sum));
  }, [salaryTypeCash]);

  useEffect(() => {
    const data = {};
    const dataArray = salaryTypesOther?.map((sals) => {
      return {
        ...data,
        description:
          sals?.employee_id?.first_name + " " + sals?.employee_id?.last_name,
        type: sals?.salary_month,
        head: "Salary",
        amount: sals?.amount,
      };
    });
    setSalaryTypesOtherData(dataArray);
    const sum = salaryTypesOther?.reduce(
      (accumulator, currentValue) =>
        accumulator + parseInt(currentValue.amount),
      0
    );
    setIncomeTotalOtherSalary(parseInt(sum));
  }, [salaryTypesOther]);

  //Fecthing Expense data for the page
  urlLink = `${process.env.REACT_APP_API_URL}/expense/${user?.church_id}`;

  const {
    data: expData,
    loading: expLoading,
    error: expenseError,
    refetch: expenseRefetch,
  } = useFetch(urlLink);

  //set setExpenseData, expenseData
  useEffect(() => {
    setExpenseData(
      expData?.expenses?.filter((d) => d?.financial_year === financial_year)
    );
  }, [expData, financial_year]);

  //Remove and set Expense cash Records expenseTypeCash, expenseTypesOther
  useEffect(() => {
    setExpenseTypeCash(
      expenseData?.filter((d) => d?.transfer_source === "Cash")
    );

    let tempExpenseTypeOther = expenseData?.filter(
      (d) => d?.transfer_source !== "Cash"
    );
    setExpenseTypesOther(tempExpenseTypeOther);
  }, [expenseData]);

  //Group Expense Type Cash
  useEffect(() => {
    function summarizeByCategory(data) {
      const summary = {};
      data?.forEach((item) => {
        const category_name = item?.category_id?.category_name;
        const amount = item?.amount;

        if (summary[category_name]) {
          summary[category_name] += amount;
        } else {
          summary[category_name] = amount;
        }
      });

      return Object.entries(summary).map(([category, total_amount]) => ({
        category,
        total_amount,
      }));
    }
    setGroupExpenseTypeCash(summarizeByCategory(expenseTypeCash));
  }, [expenseTypeCash]);

  //Add Total Grouped Expense Cash
  useEffect(() => {
    function calculateTotalAmount(data) {
      return data?.reduce((acc, item) => acc + item?.total_amount, 0);
    }
    setExpenseTotalCash(calculateTotalAmount(groupExpenseTypeCash));
  }, [groupExpenseTypeCash]);

  //Add Total Expense Others
  useEffect(() => {
    function calculateTotalAmount(data) {
      return data?.reduce((acc, item) => acc + item?.amount, 0);
    }
    setExpenseTotalOther(calculateTotalAmount(expenseTypeOthers));
  }, [expenseTypeOthers]);

  console.log(expenseTypeOthers);

  //Fecthing Active Banks for the page
  urlLink = `${process.env.REACT_APP_API_URL}/bank-balance/church/${user?.church_id}`;

  const {
    data: bankBalanceData,
    loading: bankBalanceLoading,
    error: bankBalanceError,
    refetch: bankBalanceRefetch,
  } = useFetch(urlLink);

  useEffect(() => {
    //console.log(bankBalanceData);
    setActiveBanks(
      bankBalanceData?.bankBalances?.filter((b) => {
        return b?.bank_id.active_status === true;
      })
    );
  }, [bankBalanceData]);

  useEffect(() => {
    setOpeningClosingBalances(
      activeBanks?.filter((bb) => {
        const selmonth = new Date(bb?.month);
        return (
          //  selmonth.getMonth() + 1 === +selectedMonth?.value &&
          bb?.financial_year === financial_year
        );
      })
    );
  }, [activeBanks, financial_year]);

  useEffect(() => {
    // console.log(openingClosingBalances);
    setOpeningBalTotal(
      openingClosingBalances?.reduce((accumulator, current) => {
        return accumulator + (current?.opening_balance || 0);
      }, 0)
    );

    setClosingBalTotal(
      openingClosingBalances?.reduce((accumulator, current) => {
        return accumulator + (current?.closing_balance || 0);
      }, 0)
    );
  }, [openingClosingBalances]);

  return (
    <div className="w-full overflow-hidden bg-white rounded-lg shadow-lg">
      <div className="p-6">
        <h2 className="mb-6 text-2xl font-bold text-gray-800">
          Yearly Statement
        </h2>
        {/* {JSON.stringify(user)} */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-3 font-semibold text-left text-gray-600">
                  <div className="flex items-center">
                    <FaReceipt className="mr-2" />
                    Receipts (Cash)
                  </div>
                </th>
                <th className="p-3 font-semibold text-left text-gray-600">
                  <div className="flex items-center">
                    <FaFileInvoiceDollar className="mr-2" />
                    Payments (Cash)
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 align-top">
                  <OpeningBalance
                    data={openingClosingBalances}
                    openingBalTotal={openingBalTotal}
                  />
                  <MonthlyStatementCashTables
                    data={groupIncomeTypeCash}
                    data1={receiptTotalCash}
                    total={incomeTotalCash}
                  />
                </td>
                <td className="p-3 align-top">
                  <MonthlyStatementCashTables
                    data={groupExpenseTypeCash}
                    data1={salaryTotalCash}
                    total={expenseTotalCash}
                  />
                </td>
              </tr>
              <tr className="bg-gray-100">
                <th className="p-3 font-semibold text-left text-gray-600">
                  <div className="flex items-center">
                    <RiMoneyDollarCircleLine className="mr-2" />
                    Receipts (Others)
                  </div>
                </th>
                <th className="p-3 font-semibold text-left text-gray-600">
                  <div className="flex items-center">
                    <FaMoneyBillWave className="mr-2" />
                    Payments (Others)
                  </div>
                </th>
              </tr>
              <tr>
                <td className="p-3 align-top">
                  <MonthlyStatementOtherTables
                    data={incomeTypeOthers}
                    dataSubs={subscriptionTypeOthersData}
                    total={[incomeTotalOther + incomeTotalOtherSubs]}
                  />
                </td>
                <td className="p-3 align-top">
                  <MonthlyStatementOtherTables
                    data={expenseTypeOthers}
                    dataSubs={salaryTypeOthersData}
                    total={expenseTotalOther + incomeTotalOtherSalary}
                  />
                  <ClosingBalance
                    data={openingClosingBalances}
                    closingBalTotal={closingBalTotal}
                  />
                </td>
              </tr>
              <tr>
                <td className="p-3 text-right align-top border-t">
                  <NetTotalTable
                    total={
                      incomeTotalCash +
                      incomeTotalOther +
                      incomeTotalCashSubs +
                      incomeTotalOtherSubs +
                      openingBalTotal
                    }
                  />
                </td>
                <td className="p-3 text-right align-top border-t">
                  <NetTotalTable
                    total={
                      expenseTotalCash +
                      expenseTotalOther +
                      incomeTotalCashSalary +
                      incomeTotalOtherSalary +
                      closingBalTotal
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const NetTotalTable = ({ total }) => {
  return (
    <table className="w-full">
      <tbody>
        <tr className="font-bold bg-gray-100">
          <td className="p-2 text-right">Total</td>
          <td className="p-2">{total}</td>
        </tr>
      </tbody>
    </table>
  );
};

const MonthlyStatementCashTables = ({ data, data1, total }) => {
  return (
    <table className="w-full">
      <thead>
        <tr className="bg-gray-50">
          <th className="p-2 font-semibold text-left text-gray-600">
            Description
          </th>
          <th className="p-2 font-semibold text-left text-gray-600">Amount</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr
              key={index}
              className={`${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              } hover:bg-gray-100`}
            >
              <td className="p-2">{item?.category}</td>
              <td className="p-2">{item?.total_amount}</td>
            </tr>
          ))}
        {data1 &&
          data1.map((item, index) => (
            <tr
              key={`data1-${index}`}
              className={`${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              } hover:bg-gray-100`}
            >
              <td className="p-2">{item?.category}</td>
              <td className="p-2">{item?.total_amount}</td>
            </tr>
          ))}
        <tr className="font-bold bg-gray-100">
          <td className="p-2 text-right">Total</td>
          <td className="p-2">{total + (data1?.[0]?.total_amount ?? 0)}</td>
        </tr>
      </tbody>
    </table>
  );
};

const MonthlyStatementOtherTables = ({ data, dataSubs, total }) => {
  return (
    <table className="w-full">
      <thead>
        <tr className="bg-gray-50">
          <th className="p-2 font-semibold text-left text-gray-600">
            Description
          </th>
          <th className="p-2 font-semibold text-left text-gray-600">Type</th>
          <th className="p-2 font-semibold text-left text-gray-600">Head</th>
          <th className="p-2 font-semibold text-left text-gray-600">Amount</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr
              key={index}
              className={`${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              } hover:bg-gray-100`}
            >
              <td className="p-2">
                {item?.member_id?.first_name} {item?.member_id?.last_name}
              </td>
              <td className="p-2">
                {item?.income_title ? item?.income_title : item?.expense_title}
              </td>
              <td className="p-2">{item?.category_id?.category_name}</td>
              <td className="p-2">{item?.amount}</td>
            </tr>
          ))}
        {dataSubs &&
          dataSubs.map((item, index) => (
            <tr
              key={`dataSubs-${index}`}
              className={`${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              } hover:bg-gray-100`}
            >
              <td className="p-2">{item?.description}</td>
              <td className="p-2">{item?.type}</td>
              <td className="p-2">{item?.head}</td>
              <td className="p-2">{item?.amount}</td>
            </tr>
          ))}
        <tr className="font-bold bg-gray-100">
          <td colSpan={3} className="p-2 text-right">
            Total
          </td>
          <td className="p-2">{total}</td>
        </tr>
      </tbody>
    </table>
  );
};

const OpeningBalance = ({ data, openingBalTotal }) => {
  return (
    <table className="min-w-full border border-collapse border-gray-800 table-auto">
      <thead>
        <tr>
          <th className="px-2 py-1 border-b border-l border-r border-gray-600">
            Bank Name
          </th>
          <th className="px-2 py-1 border-b border-r border-gray-600">
            Account/Head
          </th>
          <th className="px-2 py-1 border-b border-r border-gray-600">
            Opening
          </th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr
              key={index}
              className={`border-b border-gray-600 ${
                index % 2 === 0 ? "bg-white" : "bg-gray-200"
              } hover:bg-gray-300`}
            >
              <td className="px-2 py-1 border-l border-r border-gray-600">
                {item?.bank_id?.bank_name}
              </td>
              <td className="px-2 py-1 border-r border-gray-600">
                {item?.bank_id?.account_number}
              </td>
              <td className="px-2 py-1 border-r border-gray-600">
                {item?.opening_balance}
              </td>
            </tr>
          ))}

        <tr className="hover:bg-gray-300">
          <td
            colSpan={2}
            className="px-2 py-1 font-bold text-right border-l border-r border-gray-600"
          >
            Opening Total
          </td>
          <td className="px-2 py-1 border-r border-gray-600">
            {openingBalTotal}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const ClosingBalance = ({ data, closingBalTotal }) => {
  return (
    <table className="min-w-full border border-collapse border-gray-800 table-auto">
      <thead>
        <tr>
          <th className="px-2 py-1 border-b border-l border-r border-gray-600">
            Bank Name
          </th>
          <th className="px-2 py-1 border-b border-r border-gray-600">
            Account/Head
          </th>
          <th className="px-2 py-1 border-b border-r border-gray-600">
            Opening
          </th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr
              key={index}
              className={`border-b border-gray-600 ${
                index % 2 === 0 ? "bg-white" : "bg-gray-200"
              } hover:bg-gray-300`}
            >
              <td className="px-2 py-1 border-l border-r border-gray-600">
                {item?.bank_id?.bank_name}
              </td>
              <td className="px-2 py-1 border-r border-gray-600">
                {item?.bank_id?.account_number}
              </td>
              <td className="px-2 py-1 border-r border-gray-600">
                {item?.closing_balance}
              </td>
            </tr>
          ))}

        <tr className="hover:bg-gray-300">
          <td
            colSpan={2}
            className="px-2 py-1 font-bold text-right border-l border-r border-gray-600"
          >
            Closing Total
          </td>
          <td className="px-2 py-1 border-r border-gray-600">
            {closingBalTotal}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default MonthlyStatementChild;
